<template lang="pug">
#bet-status-single.modal.modal-bottom.fade.modal-bet-status(tabindex='-1' role='dialog' aria-labelledby='bet-status' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="response && response.success")
          .bet-slip(:class="{ live: betsingle.marketType == 3 }")
            .stake-info-wrapper
              .bet-status(:class="status ? 'waiting' : (betStatus === 'REJECT') ? 'reject' : 'confirm'")
                span {{ status ? $t('ui.waiting') : (betStatus === 'REJECT') ? $t('ui.reject') : $t('ui.confirm') }}
                template(v-if="status")
                  span.mr-1(v-if="counter > 0") &nbsp;({{ counter + 's' }})
                  span.mr-1(v-else) &nbsp;
                    i.fa.fa-spin.fa-spinner
              .bet-league
                img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(betsingle.sportsType)")
                template(v-if="racingList.includes(betsingle.sportsType)")
                  span {{ sports[betsingle.sportsType] }}
                template(v-else)
                  span {{ sports[betsingle.sportsType] }} - {{ betTypeDisplay }}
              .stake-info
                .betslip-match
                  .team-involved
                    template(v-if="racingList.includes(betsingle.sportsType)")
                      template(v-if="racingList2.includes(betsingle.sportsType)")
                        template(v-if="['ML','1X2'].includes(betsingle.betType)")
                          span {{ betsingle.homeAway == 1 ? betsingle.homeName : betsingle.awayName }}
                        template(v-if="['OU','OE'].includes(betsingle.betType)")
                          span {{ betsingle.homeName }}
                        template(v-if="['CS'].includes(betsingle.betType)")
                          span {{ ['5-0','4-1','3-2'].includes(betsingle.betDisplay) ? betsingle.homeName : betsingle.awayName }}
                      template(v-if="racingList6.includes(betsingle.sportsType) || racingList7.includes(betsingle.sportsType)")
                        template(v-if="['ML'].includes(betsingle.betType)")
                          span {{ betsingle.homeAway == 1 ? betsingle.homeName : betsingle.awayName }}
                        template(v-else-if="['CS','OE'].includes(betsingle.betType)")
                          span {{ betsingle.homeName }} vs {{ betsingle.awayName }}
                        template(v-else)
                          span {{ betsingle.homeName }}
                      template(v-else)
                        span {{ betsingle.homeName }}
                      span.small.ml-1(v-if="racingList.includes(betsingle.sportsType) && betsingle.matchTime") (No. {{ $dayjs(betsingle.matchTime).format("MMDDhhmm") }})
                    template(v-else)
                      //- .score(v-if="betsingle.marketType == 3 && betsingle.score != ''") {{ betsingle.score }}
                      //- span(:class="betsingle.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsingle.homeName }}
                      //- span.vs(v-if="betsingle.betType != 'OR'") - VS -
                      //- span(:class="betsingle.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsingle.betType != 'OR'") {{ betsingle.awayName }}
                      .new
                        span.d-block {{ betsingle.leagueName }}
                        span.d-block(:class="betsingle.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsingle.homeName }}
                        span.d-block(:class="betsingle.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsingle.betType != 'OR'") {{ betsingle.awayName }}
                .selector-odd.d-flex.justify-content-between
                  template(v-if="racingList.includes(betsingle.sportsType)")
                    template(v-if="racingList1.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GH_" + betsingle.betDisplay.toUpperCase()) }}
                      span.bet-type-text(v-else) {{ $t("m.GH_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                    template(v-if="racingList2.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GC_" + betsingle.betDisplay.toUpperCase()) }}
                      span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }}
                      span.bet-type-text(v-else) {{ $t("m.GC_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                    template(v-if="racingList3.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GX_" + betsingle.betDisplay.toUpperCase()) }}
                      span.bet-type-text(v-else) {{ $t("m.GX_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                    template(v-if="racingList4.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GR_" + betsingle.betDisplay.toUpperCase()) }}
                      span.bet-type-text(v-else-if="['ML','1X2'].includes(betsingle.betType)") {{ $t("m.GR_" + betsingle.betType + betsingle.betDisplay.toUpperCase().replace(".","")) }} 
                      span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }}
                      span.bet-type-text(v-else) {{ $t("m.GR_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                    template(v-if="racingList5.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.MA_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                      template(v-else-if="['ML'].includes(betsingle.betType)")
                        template(v-if="betsingle.homeName == betsingle.awayName")
                          span.bet-type-text(v-if="betsingle.homeAway==1")   {{ $t("m.MA_ANY_W_R")   }}
                          span.bet-type-text(v-else)   {{ $t("m.MA_NO_W_R")   }}
                        span.bet-type-text(v-else)  {{ $t("m.MA_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                      template(v-else-if="['CS'].includes(betsingle.betType)")
                        span.bet-type-text(v-if="betsingle.criteria2")  {{ betsingle.criteria2 }} 
                        template(v-else-if="betsingle.homeName == betsingle.awayName")
                          span.bet-type-text(v-if="['3-0'].includes(betsingle.betDisplay)")  {{ $t("m.MA_PF") }}
                          span.bet-type-text(v-else) {{ $t("m.MA_W_" + betsingle.betDisplay.split('-')[0]) }}
                        span.bet-type-text(v-else) {{ betsingle.betDisplay }}
                      span.bet-type-text(v-else) {{ $t("m.MA_" + betsingle.betType) }}
                    template(v-if="racingList6.includes(betsingle.sportsType) || racingList7.includes(betsingle.sportsType)")
                      span.bet-type-text(v-if="['ML','OE'].includes(betsingle.betType)") {{ $t("m.CF_" + betsingle.betType + (betsingle.homeAway == undefined ? '' : betsingle.homeAway)) }}
                      span.bet-type-text(v-else-if="['CS'].includes(betsingle.betType)") {{ betsingle.betDisplay }}
                      span.bet-type-text(v-else) {{ $t("m.CF_" + betsingle.betType) }}
                    .bet-type-odds
                      .odds
                        span(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
                  template(v-else)
                    span.text(:class="isBallDisplay == false ? '' : ((betsingle.giving == 0 && betsingle.homeAway == 2) ? 'team2' : (betsingle.giving == 1 && betsingle.homeAway == 1) ? 'team2' : 'team1')") {{ betsingle.marketType == 3 && betsingle.score != '' ? "[" + betsingle.score + "]" : "" }}
                      | {{ betsingle.betType }} | {{ betsingle.betDisplay }}
                      template(v-if="!!time_machine.minutesOddsData && time_machine.minutesOddsData.length> 0") 
                          | {{ (checkTeam(betsingle) === 1 ? betsingle.homeName : betsingle.awayName)}}
                          | {{displayTimeRange()}}
                      template(v-if="['1X2OU', 'DCOU', 'OUOE'].includes(betsingle.betType)") &nbsp;({{ betsingle.criteria2 }})
                    .bet-type-odds
                      span.bet-type-text {{ ballDisplay }}
                      .odds
                        span(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
              .payout-wrapper
                .left {{ $t("ui.stake")}}: {{ $numeral(betsingle.stake).format("0,0.00[0]") }}
                .right {{ $t("ui.payout")}}: {{ $numeral(betsingle.payout).format("0,0.00[0]") }}
          .btn-continue(@click="hideMe()") {{ $t("ui.continue_bet") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import naming from "@/library/_name";
import xhr from "@/library/_xhr-bet.js";

export default {
  components: {},
  data() {
    return {
      betsingle: {},
      items: [],
      response: null,
      status: false,
      betStatus: "",
      checkCounter: null,
      counter: 5
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    ballDisplay() {
      return naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
    },
    isBallDisplay() {
      var result = naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
      if (["HDP", "HDPH"].includes(this.betsingle.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    betTypeDisplay() {
      return this.$t("m.BS_" + this.betsingle.betType);
    },
    commType() {
      return this.$store.getters.commType;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    debug() {
      return config.debugMode;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace("UST", "USDT");
    },
    isDataExists() {
      if (this.betsingle.hasOwnProperty("val")) {
        return true;
      } else {
        return false;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    time_machine() {
      return this.$store.getters.timeMachine || {};
    }
  },
  destroyed() {},
  mounted() {
    EventBus.betSingleStatus = this.runbet;
    $("#bet-status-single").on("hidden.bs.modal", () => {
      var _this = this;
      clearInterval(_this.checkCounter);
    });
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    runbet(e, f) {
      this.betsingle = e;
      this.response = f;
      this.status = f.data.pending;
      this.showMe();
    },
    showMe() {
      $("#bet-status-single").modal("show");
      this.betStatus = "";
      if (this.status) {
        this.checkCounter = setInterval(this.handleCounter, 1000);
      }
    },
    hideMe() {
      $("#bet-status-single").modal("hide");
      clearInterval(this.checkCounter);
      this.$store.commit("timemachine/RESET_STATE");
    },
    handleCounter() {
      if (this.counter > 0) {
        this.counter -= 1;
      } else {
        this.populateList();
        this.counter = 5;
      }
    },
    populateList(callback) {
      if (this.isLoggedIn) {
        this.loading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: this.response.data.betId,
          bet_type: this.betsingle.betType
        };
        xhr.betStatus(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                var betId = res.data[0].bet_id;
                this.betStatus = res.data[0].bet_status;
                this.status = res.data[0].bet_status === "PENDING";
                if (this.betStatus != "PENDING") {
                  clearInterval(this.checkCounter);
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    checkTeam(betSelected) {
      if (betSelected.giving == 0 && betSelected.homeAway == 2) return 2;
      else if (betSelected.giving == 1 && betSelected.homeAway == 1) return 2;
      else return 1;
    },
    displayTimeRange() {
      const default_start = 0;
      var range_end = this.betsingle.tm_time;

      if (!!this.time_machine.minutesOddsData && this.time_machine.minutesOddsData.length > 0) {
        return "(" + [String(default_start).padStart(2, "0") + ":00", String(range_end).padStart(2, "0") + ":00"].join(" - ") + ")";
      } else return "";
    }
  }
};
</script>
